module.exports = __webpack_public_path__ + "static/img/2 -2.2c809f4b.jpg";